// PageWithSidebar.js
import React from "react";

import { Route, Routes, useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";

import DownHoleTool from "../DownHoleTool/DownHoleTool";
import PerformancePacker from "../HighPerformancePacker/Category/PerformancePacker";
import SwellablePacker from "../HighPerformancePacker/Category/Swellable";
import HRPacker from "../HighPerformancePacker/Category/HR";
import IPIsolation from "../HighPerformancePacker/Category/IPIsolation";
// import Y211 from "../HighPerformancePacker/Category/Y211";
// import Y341Injection from "../HighPerformancePacker/Category/Y341Injection";
// import Y531Fracturing from "../HighPerformancePacker/Category/Y531Fracturing";
// import PRHSProduction from "../HighPerformancePacker/Category/PRHSProduction";
// import DESPCable from "../HighPerformancePacker/Category/DESPCable";

import QualitySandControlScreen from "../QualitySandControlScreen/Category/QualitySandControlScreen";
import JMPremiumScreen from "../QualitySandControlScreen/Category/JMPremiumScreen";

// import ToolDetail from "../DownHoleTool/ToolDetail";
import SwellableDetail from "../HighPerformancePacker/CategoryDetail/Swellable/SwellableDetail";
import HRDetail from "../HighPerformancePacker/CategoryDetail/HR/HRDetail";
import IPIsolationDetail from "../HighPerformancePacker/CategoryDetail/IPIsolation/IPIsolationDetail";

import PremimumScreenDetail from "../QualitySandControlScreen/CategoryDetail/PremiumScreen/PremiumScreenDetail";

import SliderImage from "../SliderImage";
// Import other component pages

const PageWithSidebar = () => {
  const location = useLocation();
  // const params = useParams();
  return (
    <Box>
      <SliderImage />
      <Box
        // sx={{
        //   display: "flex",
        //   // flexDirection: { xs: "column", sm: "column", md: "row" },
        // //   justifyContent:"center",
        //   pt: { xs: 4, sm: 12 },
        //   pb: { xs: 8, sm: 16 },

        // }}

        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row" },
          //  justifyContent:"center",
          pt: { xs: 4, sm: 12 },
          pb: { xs: 8, sm: 16 },
        }}
      >
        <Box
          sx={{
            // maxWidth: "100%",
            // maxwidth: "150px",
            //  minWidth:"150px"
           
          }}
        >
          <Sidebar />
        </Box>
        <Box
          sx={{
            // flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // flexWrap:"wrap",
            //width:"400px"
            //minWidth:"320px"
            width: "100%",
            // maxWidth: "220px",
          //  width:"100%"
            
          }}
        >
          {location.pathname === "/tool" && <DownHoleTool />}
          <Routes>
            <Route path="/100" element={<PerformancePacker />} />
            <Route path="/3" element={<SwellablePacker />} />
            <Route path="/2" element={<HRPacker />} />
            <Route path="/1" element={<IPIsolation />} />

            <Route path="/101" element={<QualitySandControlScreen />} />
            <Route path="/9" element={<JMPremiumScreen />} />

            {/* <Route path="/details/:toolId" element={<ToolDetail/>} /> */}
            <Route path="/details/3" element={<SwellableDetail />} />
            <Route path="/details/2" element={<HRDetail />} />
            <Route path="/details/1" element={<IPIsolationDetail />} />

            <Route path="/details/9" element={<PremimumScreenDetail/>} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
};

export default PageWithSidebar;
